<div [attr.id]="containerUniqueId" [ngStyle]="{ width: containerWidth, height: containerHeight }"></div>
